var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccordionExpandIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20312 6.52344C1.09896 6.63281 1.01823 6.75 0.960938 6.875C0.908854 7 0.882812 7.14062 0.882812 7.29688C0.882812 7.5 0.932292 7.6849 1.03125 7.85156C1.13021 8.01823 1.26302 8.15365 1.42969 8.25781C1.59635 8.35677 1.78385 8.40625 1.99219 8.40625C2.30469 8.40625 2.57292 8.28906 2.79688 8.05469L7.92969 2.78125H7.29688L12.4062 8.05469C12.6302 8.28906 12.901 8.40625 13.2188 8.40625C13.4219 8.40625 13.6068 8.35677 13.7734 8.25781C13.9401 8.15365 14.0729 8.01823 14.1719 7.85156C14.2708 7.6849 14.3203 7.5 14.3203 7.29688C14.3203 6.98958 14.2161 6.73177 14.0078 6.52344L8.5 0.898438C8.36458 0.757812 8.22396 0.65625 8.07812 0.59375C7.93229 0.526042 7.77344 0.492188 7.60156 0.492188C7.27344 0.492188 6.97396 0.627604 6.70312 0.898438L1.20312 6.52344Z",
    fill: "#2B2727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionExpandIcon);
export default __webpack_public_path__ + "static/media/accordion-expand-icon.5bdf46beccef9f213feb34a4f777fa70.svg";
export { ForwardRef as ReactComponent };